import { streamRng } from './rng.js';

/**
 * Мир за ночь перетасовывается: где стоят тачки, что где лежит.
 * Состояние мира не хранится в сейве — оно выводится из сида и номера дня,
 * поэтому одинаковый сид даёт одинаковый двор, а сейв не пухнет.
 * Персистентно только то, что игрок успел тронуть (см. looted).
 */

export interface CarSpot {
  x: number;
  y: number;
}

export interface SpawnedCar {
  /** Устойчивый идентификатор на день: по нему помечается «уже вскрыта». */
  id: string;
  zone: string;
  x: number;
  y: number;
  model: string;
  /** Приметность: с ней в M3 будут работать патрули. */
  flashy: boolean;
}

const MODELS = ['kopeyka', 'zubilo', 'moskvich', 'volga', 'bumer'] as const;

/** Сколько мест из доступных занято тачками этой ночью. */
function occupancy(total: number, roll: number): number {
  if (total === 0) return 0;
  return Math.max(1, Math.round(total * (0.35 + roll * 0.45)));
}

/**
 * Расстановка тачек по зоне на конкретный день.
 * Чистая функция: тот же сид и день — та же расстановка на любой машине.
 */
export function spawnCars(seed: string, day: number, zoneId: string, spots: readonly CarSpot[]): SpawnedCar[] {
  if (spots.length === 0) return [];
  const rng = streamRng(seed, `cars:${zoneId}`, day);

  const shuffled = [...spots];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = rng.int(0, i);
    [shuffled[i], shuffled[j]] = [shuffled[j]!, shuffled[i]!];
  }

  const count = occupancy(shuffled.length, rng.next());
  return shuffled.slice(0, count).map((spot, index) => {
    const model = MODELS[rng.int(0, MODELS.length - 1)]!;
    return {
      id: `${zoneId}:${day}:${index}:${spot.x}-${spot.y}`,
      zone: zoneId,
      x: spot.x,
      y: spot.y,
      model,
      flashy: model === 'bumer' || model === 'volga',
    };
  });
}
